import React, { useState } from "react";
import { ArrowSquareOut } from "@phosphor-icons/react";
import { legalLinks } from "@/lib/legal";
import { LegalDocEditor } from "./LegalDocEditor";

const VIEW_LINK = { privacy: "privacy", terms: "terms", partners: "partners" };

function TokenHelp({ tokens }) {
  return (
    <details className="mt-3 border-2 border-zinc-300 p-2 text-[11px]" data-testid="legal-token-help">
      <summary className="cursor-pointer label-mono">Fill-in words you can use</summary>
      <ul className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-1">
        {tokens.map((t) => <li key={t.token}><span className="font-mono">{t.token}</span> — {t.means}</li>)}
      </ul>
      <p className="mt-2 text-zinc-600">Use ## for a heading, - for a bullet and **text** for bold.</p>
    </details>
  );
}

export const LegalPagesManager = ({ data, pageId, onSaved }) => {
  const [active, setActive] = useState(data.docs[0]?.kind);
  const doc = data.docs.find((d) => d.kind === active) || data.docs[0];
  const links = legalLinks(data.buyer?.code);
  const viewKey = VIEW_LINK[doc.kind];
  return (
    <div data-testid={`legal-manager-${pageId ? "buyer" : "shared"}`}>
      <div className="flex flex-wrap gap-1.5 mb-3">
        {data.docs.map((d) => (
          <button key={d.kind} type="button" onClick={() => setActive(d.kind)} data-testid={`legal-tab-${d.kind}`}
                  className={`border-2 border-black px-2.5 py-1 text-[10px] uppercase tracking-widest ${d.kind === doc.kind ? "bg-black text-white" : "bg-white hover:bg-zinc-100"}`}>
            {d.title}{d.is_custom ? " •" : ""}
          </button>
        ))}
        {viewKey && (
          <a href={links[viewKey]} target="_blank" rel="noopener noreferrer" data-testid={`legal-view-live-${doc.kind}`}
             className="ml-auto text-[10px] uppercase tracking-widest underline inline-flex items-center gap-1 self-center">
            View live page <ArrowSquareOut size={11} weight="bold" />
          </a>
        )}
      </div>
      <LegalDocEditor key={`${pageId || "global"}-${doc.kind}`} doc={doc} pageId={pageId} canEdit={data.can_edit} onSaved={onSaved} />
      <TokenHelp tokens={data.tokens} />
    </div>
  );
};
